module.exports = __webpack_public_path__ + "img/Agents-Homepage.77448b5.png";